import { render, staticRenderFns } from "./NormalNotice.vue?vue&type=template&id=1a048e18&scoped=true&"
import script from "./NormalNotice.vue?vue&type=script&lang=js&"
export * from "./NormalNotice.vue?vue&type=script&lang=js&"
import style0 from "./NormalNotice.vue?vue&type=style&index=0&id=1a048e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a048e18",
  null
  
)

export default component.exports